import { useState } from 'react';

interface HelpPopoverProps {
  title: string;
  description: string;
  tips?: string[];
}

export default function HelpPopover({ title, description, tips }: HelpPopoverProps) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        className="help-popover-trigger"
        onClick={() => setOpen(!open)}
        title="Show help"
      >
        ?
      </button>

      {open && (
        <>
          <div className="help-popover-backdrop" onClick={() => setOpen(false)} />
          <div className="help-popover">
            <div className="help-sidebar-header">
              <h3 className="help-sidebar-title">{title}</h3>
              <button
                className="help-sidebar-close"
                onClick={() => setOpen(false)}
                title="Close"
              >
                ✕
              </button>
            </div>
            <p className="help-sidebar-desc">{description}</p>
            {tips && tips.length > 0 && (
              <div className="help-sidebar-tips">
                <h4>Tips</h4>
                <ul>
                  {tips.map((tip, i) => (
                    <li key={i}>{tip}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
